import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#category', label: '栏目导航' },
  { href: '#topic', label: '专题板块' },
  { href: '#featured', label: '大图精选' },
  { href: '#tags', label: '标签目录' },
  { href: '#faq', label: '常见问题' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? 'border-b border-background-200 bg-background-50/95 backdrop-blur'
          : 'border-b border-transparent bg-background-50/60 backdrop-blur-sm'
      }`}
    >
      <div className="flex h-16 items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-grid-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold text-foreground-950">黑料网1</span>
            <span className="mt-0.5 text-[10px] tracking-widest text-foreground-500">分类导航站</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#tags"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            进入标签目录
          </a>
          <button
            type="button"
            aria-label="展开导航"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#tags"
              onClick={() => setMenuOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              进入标签目录
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}